import { atom } from "jotai";

import { EventCapacityType } from "../components/__generated__/FormStepManager_event.graphql";
import { UnknownGuestPrimaryChargePaymentMap } from "../types";

export const unknownGuestsAssignedToPayersAtom = atom<
  UnknownGuestPrimaryChargePaymentMap[]
>([]);

export const eventRemainingCapacityAtom = atom<{
  capacityType: EventCapacityType;
  remainingCapacity: number;
} | null>(null);
